import styled from 'styled-components';
import {Button} from '@/components/Button';
import {Modal} from '@/components/Modal';
import {Typography, typographyStyle} from '@/components/Typography';
import {PaddingBox} from '@/styled-components';
import {palette} from '@/styles';
import InfoImage from './img_rankingboard.png';

interface IProps {
  onClose(): void;
}

const CONTENT = [
  {
    title: '지도에 표시된 블록은 무엇을 의미하나요?',
    desc: '시군구 내 매출액 상위 10% 지역이 블록으로 표시됩니다.',
  },
  {
    title: '블록에 표시된 매출액은 어떤 의미인가요?',
    desc: '블록 내 조회 업종 매장들의 최근 월 추정 매출액 평균 값을 의미합니다.(법인이 운영하는 매장은 산출 대상에 포함되지 않습니다.)',
  },
  {
    title: '블록의 평균 매출액 산출 방법이 궁금해요.',
    desc: '평균 매출액은 블록 내 조회 업종에 해당하는 모든 매장의 매출을 평균 낸 값입니다. 블록에 매출이 낮은 매장이 포함되었을 경우, 평균값이 다소 낮게 산출될 수 있습니다. 이로 인해 매출이 높은 매장이 있는 블록이라도 랭킹보드에 선정되지 않을 수 있습니다.',
  },
];

export const InfoModal = ({onClose}: IProps) => {
  return (
    <Modal title="매출액이 높은 상권이란?" width={560} onClose={onClose}>
      <Body>
        <img src={InfoImage} width="100%" alt="매출액이 높은 상권이란?" />
        {CONTENT.map((i) => (
          <PaddingBox top={24} key={i.title}>
            <strong>{i.title}</strong>
            <PaddingBox top={4}>
              <Typography color={palette.textSecondary}>{i.desc}</Typography>
            </PaddingBox>
          </PaddingBox>
        ))}
      </Body>
      <PaddingBox left={16} right={16} bottom={24}>
        <Button
          variant="fill"
          size="medium"
          color="secondary"
          fullWidth
          onClick={onClose}
        >
          확인
        </Button>
      </PaddingBox>
    </Modal>
  );
};

const Body = styled.div`
  padding: 16px;
  ${{...typographyStyle.medium14}}
`;
